import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import * as formInputNames from '../../../../consts/form/formInputNames';
import * as formItemTypes from '../../../../consts/form/formItemTypes';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import organizationsService from '../../../../services/organizations/organizationsService';
import {makeSelectOrganizationsNames} from '../../../../state/selectors/organizations';
import {makeSelectKvkSettingsData} from '../../../../state/selectors/services';
import helpers from '../../../../utils/helpers';
import regexUtils from '../../../../utils/regexUtils';

const getFormContent = (form) => {
    const localizedStrings = getLocalizedStrings();

    const settings = useSelector(makeSelectKvkSettingsData()) || {};

    const [selectedScheduleDate, setSelectedScheduleDate] = useState(settings?.scheduleDate || '');
    const [specificDaysOfMonth2, setSpecificDaysOfMonth2] = useState('');
    const [specificDayOfWeek2, setSpecificDayOfWeek2] = useState('');

    useEffect(() => {
        if (settings?.schedule) {
            const cronParts = settings.schedule.split(' ');

            if (
                cronParts.length === 6 &&
                cronParts[0] === '0' &&
                cronParts[1] === '59' &&
                cronParts[2] === '21' &&
                /^[0-9,]+$/.test(cronParts[3]) &&
                cronParts[4] === '*' &&
                cronParts[5] === '?'
            ) {
                setSelectedScheduleDate(`0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?`);
                setSpecificDaysOfMonth2(cronParts[3]);
            }

            if (
                cronParts.length === 6 &&
                cronParts[0] === '0' &&
                cronParts[1] === '59' &&
                cronParts[2] === '21' &&
                cronParts[3] === '?' &&
                cronParts[4] === '*' &&
                /^[A-Za-z]+(,[A-Za-z]+)*$/.test(cronParts[5])
            ) {
                setSelectedScheduleDate(`0 59 21 ? * ${form.getFieldValue(formInputNames.SPECIFIC_DAY_OF_WEEK)}`);
                setSpecificDayOfWeek2(cronParts[5]);
            }

            console.log('Month: ', specificDaysOfMonth2);
            console.log('Day: ', specificDayOfWeek2);
        }
    }, [settings]);

    const handleChange = (value, fieldName) => {
        if (fieldName === 'scheduleDate') {
            if (value === 'specificDaysOfMonth') {
                setSpecificDayOfWeek2('');
            } else if (value === 'specificDayOfWeek') {
                setSpecificDaysOfMonth2('');
            }
            setSelectedScheduleDate(value);
        }
        console.log(`Значення для ${fieldName}:`, value);
    };

    const initialValues = {
        ...settings,

        [formInputNames.COMPANY]: settings?.organizationID,
        loginExUrl: settings?.loginExUrl || '',
        baseUrl: settings?.baseUrl || '',
        executeExUrl: settings?.executeExUrl || '',
        login: settings?.login || '',
        [formInputNames.PASSWORD]: settings?.password,
        schedule: (() => {
            if (settings?.schedule) {
                const cronParts = settings.schedule.split(' ');

                if (
                    cronParts.length === 6 &&
                    cronParts[0] === '0' &&
                    cronParts[1] === '59' &&
                    cronParts[2] === '21' &&
                    /^[0-9,]+$/.test(cronParts[3]) &&
                    cronParts[4] === '*' &&
                    cronParts[5] === '?'
                ) {
                    return 'День/дні місяця';
                }

                if (
                    cronParts.length === 6 &&
                    cronParts[0] === '0' &&
                    cronParts[1] === '59' &&
                    cronParts[2] === '21' &&
                    cronParts[3] === '?' &&
                    cronParts[4] === '*' &&
                    /^[A-Za-z]+(,[A-Za-z]+)*$/.test(cronParts[5])
                ) {
                    return 'День/дні тижня';
                }
            }
            return settings?.schedule || 'Розклад';
        })(),
        specificDayOfWeek: specificDayOfWeek2,
        specificDaysOfMonth: specificDaysOfMonth2,
    };

    const formFields = [
        {
            key: helpers.guid(),
            formItemType: formItemTypes.SELECT,
            fieldLabel: 'name',
            required: true,
            name: formInputNames.COMPANY,
            label: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_COMPANY_FIELD_LABEL],
            placeholder: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_COMPANY_FIELD_PLACEHOLDER],
            errorMessage: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_COMPANY_FIELD_ERROR],
            requestOptions: {
                selectRequestData: makeSelectOrganizationsNames,
                getRequestData: () => organizationsService.getOrganizationsNames(),
            },
        },
        {
            key: helpers.guid(),
            required: true,
            name: formInputNames.LOGIN,
            label: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_FIELD_FTP_LOGIN_LABEL],
            placeholder: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_FIELD_FTP_LOGIN_PLACEHOLDER],
            errorMessage: localizedStrings[localizationKeys.NOTIFICATION_SERVICE_FORM_FIELD_ERROR],
        },
        {
            key: helpers.guid(),
            formItemType: formItemTypes.PASSWORD,
            name: formInputNames.PASSWORD,
            required: true,
            label: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_FIELD_FTP_PASSWORD_LABEL],
            placeholder: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_FIELD_FTP_PASSWORD_PLACEHOLDER],
            errorMessage: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_FIELD_FTP_PASSWORD_ERROR],
        },
        {
            key: helpers.guid(),
            required: true,
            name: 'loginExUrl',
            label: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_LOGIN_EX_URL_FIELD_LABEL],
            maxLength: 100,
            placeholder: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_LOGIN_EX_URL_FIELD_PLACEHOLDER],
            errorMessage: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_LOGIN_EX_URL_FIELD_ERROR],
        },
        {
            key: helpers.guid(),
            required: true,
            maxLength: 100,
            name: 'executeExUrl',
            label: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_EXECUTE_EX_URL_FIELD_LABEL],
            placeholder: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_EXECUTE_EX_URL_FIELD_PLACEHOLDER],
            errorMessage: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_EXECUTE_EX_URL_FIELD_ERROR],
        },
        {
            key: helpers.guid(),
            row: false,
            required: true,
            name: 'baseUrl',
            label: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_BASE_URL_FIELD_LABEL],
            maxLength: 100,
            placeholder: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_BASE_URL_FIELD_PLACEHOLDER],
            errorMessage: localizedStrings[localizationKeys.SERVICE_CONFIGURE_KVK_FORM_BASE_URL_FIELD_ERROR],
        },
        {
            key: 'schedule',
            name: 'schedule',
            formItemType: 'SELECT',
            label: 'Розклад відправки даних',
            onChange: (value) => handleChange(value, 'scheduleDate'),
            requestOptions: {
                options: [
                    {label: 'Щогодини', key: '0 0 * ? * *'},
                    {label: 'Щодоби', key: '0 59 21 * * ?'},
                    {label: 'Раз на тиждень', key: '0 59 21 ? * MON *'},
                    {label: 'Останній день місяця', key: '0 59 21 L * ? *'},
                    {label: 'Перший день місяця', key: '0 59 21 1 * ? *'},
                    {
                        label: 'День/дні місяця',
                        key: `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?`,
                    },
                    {
                        label: 'День/дні тижня',
                        key: `0 59 21 ? * ${form.getFieldValue(formInputNames.SPECIFIC_DAY_OF_WEEK)}`,
                    },
                ],
            },
        },
        {
            key: 'dynamicInput',
            formItemType: 'INPUT',
            name:
                selectedScheduleDate === `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?`
                    ? 'specificDaysOfMonth'
                    : 'specificDayOfWeek',
            required:
                selectedScheduleDate === `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?` ||
                selectedScheduleDate === `0 59 21 ? * ${form.getFieldValue(formInputNames.SPECIFIC_DAY_OF_WEEK)}`,
            label:
                selectedScheduleDate === `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?`
                    ? 'День/дні місяця'
                    : 'День/дні тижня',
            pattern:
                selectedScheduleDate === `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?`
                    ? regexUtils.DAY_OF_MONTH_REGEX
                    : regexUtils.DAY_OF_WEEK_REGEX,
            placeholder:
                selectedScheduleDate === `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?`
                    ? 'Введіть дні місяця'
                    : 'Введіть дні тижня',
            className:
                selectedScheduleDate === `0 59 21 ${form.getFieldValue(formInputNames.SPECIFIC_DAYS_OF_MONTH)} * ?` ||
                selectedScheduleDate === `0 59 21 ? * ${form.getFieldValue(formInputNames.SPECIFIC_DAY_OF_WEEK)}`
                    ? ''
                    : 'hidden',
        },
    ];

    return {
        formFields,
        initialValues,
    };
};

export default {
    getFormContent,
};
